// extracted by mini-css-extract-plugin
module.exports = {"message":"PhishReveal_message__43tHc"};